import React from "react";
import { FormGridColumnTypes } from "../../types/FormGrids";
import { BulkRadioButtons, BulkCheckbox } from "./FormGridComponents";
export function TableBulkAction({ headings, form, }) {
    return (React.createElement("tr", { className: "table__bulk-action" }, form?.name &&
        headings.map((heading, i) => {
            if (i === 0 && form.bulkActionLabel) {
                return (React.createElement("td", { key: i },
                    React.createElement("span", { className: "font-weight-bold" }, form.bulkActionLabel)));
            }
            if (!heading.formComponent?.bulkAction) {
                return React.createElement("td", { key: i });
            }
            return (React.createElement("td", { key: i },
                heading.formComponent?.type === FormGridColumnTypes.Radio && (React.createElement(BulkRadioButtons, { name: form?.name, formComponent: heading.formComponent })),
                heading.formComponent?.type === FormGridColumnTypes.Checkbox && (React.createElement(BulkCheckbox, { name: form.name, formComponent: heading.formComponent }))));
        })));
}
